/* eslint camelcase: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import Divider from '@material-ui/core/Divider';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

import Samples from './Inputs/Samples';
import ModelType from './Inputs/ModelType';
import NumberOfPoints from './Inputs/NumberOfPoints';

const styles = theme => ({
  root: {
    width: '100%',
    overflowY: 'auto',
    height: 'calc(100vh - 120px)',
  },
  formControl: {
    margin: `${theme.spacing.unit * 2}px`
  },

  leftChild: {
    marginRight: `${theme.spacing.unit / 2}px`,
  },

  rightChild: {
    marginLeft: `${theme.spacing.unit / 2}px`,
  },

  navButtonContainer: {
    padding: theme.spacing.unit * 2,
    justifyContent: 'space-around',
    display: 'inline-flex',
    width: '100%',
  },
  drawerBottom: {
    backgroundColor: 'rgba(225,225,225,0.5)',
    width: '330px',
    bottom: '0px',
    position: 'fixed',
  },
  drawerActionButton: {
    width: '128px',
  },
  buttonWrapper: {
    position: 'relative',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  twoFieldWrapper: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: `${theme.spacing.unit / 2}px`,
  },
});

class ConfigForm extends React.Component {
  /** return true if the contents on the card and those on the DB are different */
  wasEdited = () => {
    return false;
  };

  isCurrentStateInvalid = () => {
    return this.isNumberOfPointsInvalid() || this.isSampleCountInvalid(); // TODO add more
  };

  /** return true if the contents on the card are valid  and if the model is not already running */
  isRunnable = () => {
    return !this.props.isQuantifying;
  };

  isSampleCountInvalid = () => {
    return Number.isNaN(this.props.selected.samples) || Number(this.props.selected.samples) <= 99;
  };

  isNumberOfPointsInvalid = () => {
    const { number_of_pts } = this.props.selected;
    return Number.isNaN(number_of_pts) || Number(number_of_pts) <= 0;
  };


  render() {
    const {
      classes,
      onSave,
      onQuantify,
      onRemoveLikelihoodParamsComponentResult,
      hideActions,
      disable,
      errs,
      findErrors,
    } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.formControl} style={{"paddingBottom" : (findErrors(errs).length + 1) * 16}}>
          <ModelType
            selected={{
              model_type: this.props.selected.model_type,
              likelihood: this.props.selected.likelihood,
              prior: this.props.selected.prior,
            }}
            onUpdateModelType={this.props.onUpdateModelType}
            onUpdatePriorDist={this.props.onUpdatePriorDist}
            onUpdatePriorParamsType={this.props.onUpdatePriorParamsType}
            onUpdatePriorParamsValues={this.props.onUpdatePriorParamsValues}
            onUpdatePriorParamsComponentResult={this.props.onUpdatePriorParamsComponentResult}
            onUpdateLikelihoodDist={this.props.onUpdateLikelihoodDist}
            onUpdateLikelihoodParamsType={this.props.onUpdateLikelihoodParamsType}
            onAddLikelihoodParamsValues={this.props.onAddLikelihoodParamsValues}
            onAddLikelihoodParamsList={this.props.onAddLikelihoodParamsList}
            onRemoveLikelihoodParamsValues={this.props.onRemoveLikelihoodParamsValues}
            onUpdateLikelihoodParamsValues={this.props.onUpdateLikelihoodParamsValues}
            onAddLikelihoodParamsComponentResult={this.props.onAddLikelihoodParamsComponentResult}
            onRemoveLikelihoodParamsComponentResult={onRemoveLikelihoodParamsComponentResult}
            disable={disable}
          />
          <div className={classes.twoFieldWrapper}>
            <div className={classes.leftChild}>
              <NumberOfPoints
                onUpdate={this.props.onUpdateNumPoints}
                selected={this.props.selected.number_of_pts}
                invalid={this.isNumberOfPointsInvalid()}
              />
            </div>
            <div className={classes.rightChild}>
              <Samples
                onUpdate={this.props.onUpdateSampleCount}
                selected={this.props.selected.samples}
                invalid={this.isSampleCountInvalid()}
              />
            </div>
          </div>
        </div>
        {/* Action Buttons */}
        {
          !hideActions && (
            <Paper className={classes.drawerBottom}>
              <Divider />
              <div className={classes.navButtonContainer}>
                <div className={classes.buttonWrapper}>
                  <Tooltip title="Save">
                    <Button
                      disabled={this.isCurrentStateInvalid() || this.props.isSaving}
                      variant="contained"
                      color="secondary"
                      size="large"
                      aria-label="Save"
                      className={classes.drawerActionButton}
                      onClick={e => onSave(e, this.state)}
                    >
                      Save
                    </Button>
                  </Tooltip>
                  {
                    this.props.isSaving &&
                    <CircularProgress size={24} className={classes.buttonProgress} />
                  }
                </div>
                <div className={classes.buttonWrapper}>
                  <Tooltip title="Quantify">
                    <Button
                      disabled={this.props.isQuantifying || this.props.isSaving}
                      variant="contained"
                      color="primary"
                      size="large"
                      aria-label="Quantify"
                      className={classes.drawerActionButton}
                      onClick={e => onQuantify(e, this.state)}
                    >
                      Estimate
                    </Button>
                  </Tooltip>
                  {
                    this.props.isQuantifying &&
                    <CircularProgress size={24} className={classes.buttonProgress} />
                  }
                </div>
              </div>
            </Paper>
          )
        }
      </div>
    );
  }
}

ConfigForm.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  onSave: PropTypes.instanceOf(Function).isRequired,
  onQuantify: PropTypes.instanceOf(Function).isRequired,
  onUpdateModelType: PropTypes.instanceOf(Function).isRequired,
  onUpdateSampleCount: PropTypes.instanceOf(Function).isRequired,
  onUpdateNumPoints: PropTypes.instanceOf(Function).isRequired,
  onUpdatePriorDist: PropTypes.instanceOf(Function).isRequired,
  onUpdatePriorParamsType: PropTypes.instanceOf(Function).isRequired,
  onUpdatePriorParamsValues: PropTypes.instanceOf(Function).isRequired,
  onUpdatePriorParamsComponentResult: PropTypes.instanceOf(Function).isRequired,
  onUpdateLikelihoodDist: PropTypes.instanceOf(Function).isRequired,
  onUpdateLikelihoodParamsType: PropTypes.instanceOf(Function).isRequired,
  onAddLikelihoodParamsValues: PropTypes.instanceOf(Function).isRequired,
  onAddLikelihoodParamsList: PropTypes.instanceOf(Function).isRequired,
  onRemoveLikelihoodParamsValues: PropTypes.instanceOf(Function).isRequired,
  onUpdateLikelihoodParamsValues: PropTypes.instanceOf(Function).isRequired,
  onAddLikelihoodParamsComponentResult: PropTypes.instanceOf(Function).isRequired,
  onRemoveLikelihoodParamsComponentResult: PropTypes.instanceOf(Function).isRequired,
  isSaving: PropTypes.bool.isRequired,
  isQuantifying: PropTypes.bool.isRequired,
  selected: PropTypes.shape({
    samples: PropTypes.number,
    model_type: PropTypes.string.isRequired,
    number_of_pts: PropTypes.number.isRequired,
    likelihood: PropTypes.shape({
      dist: PropTypes.string,
      params_type: PropTypes.string,
      params: PropTypes.shape({
        component_result: PropTypes.arrayOf(Number).isRequired,
        values: PropTypes.arrayOf(PropTypes.arrayOf(Number)).isRequired,
      }).isRequired,
    }).isRequired,
    prior: PropTypes.shape({
      dist: PropTypes.string,
      params_type: PropTypes.string,
      params: PropTypes.shape({
        component_result: PropTypes.number,
        values: PropTypes.arrayOf(Number).isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

export default withStyles(styles)(ConfigForm);
